module.exports = __webpack_public_path__ + "static/media/300x209 Komplit 2.7e841592.svg";


//////////////////
// WEBPACK FOOTER
// ./src/component/img/device/300x209 Komplit 2.svg
// module id = 976
// module chunks = 2